import { Box, Button, HStack, Icon, SearchInput, Stack, Text } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { VStack } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import {
  fixedFeeTermsFiltersAtom,
  fixedFeeTermsOrderByAtom,
} from '../../../../../../store/fixedFee/atom';
import { fixedFeeSearchPlaceholder } from '../../constants';

import { FixedFeeTermsHeaderProps } from '.';

export const FixedFeeTermsHeaderMobile: React.FC<FixedFeeTermsHeaderProps> = ({
  onSearch,
  onClearSearch,
  onRefresh,
  disabled,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(fixedFeeTermsFiltersAtom);
  const { appliedOrderBy } = useRecoilValue(fixedFeeTermsOrderByAtom);

  const hasSelection = appliedOrderBy !== undefined;

  return (
    <VStack space="stack.nano">
      <SearchInput
        isMobile
        onSearch={onSearch}
        onClear={onClearSearch}
        placeholder={fixedFeeSearchPlaceholder}
        isLoading={disabled}
      />

      <HStack alignItems="center" space="inline.nano" justifyContent="space-between">
        <HStack alignItems="center" space="inline.nano">
          <Button
            variant="secondary"
            onPress={onRefresh}
            paddingBottom="stack.xxxs"
            paddingTop="stack.xxxs"
            paddingLeft="inline.xxxs"
            paddingRight="inline.xxxs"
            h={undefined}
            isDisabled={disabled}
            _text={{ textTransform: 'none' }}>
            <Icon name="Refresh" size="xxxs" color="neutral.black" />
          </Button>

          <Button
            variant="secondary"
            onPress={() => navigate('FixedFeeOrderModal')}
            paddingBottom="stack.xxxs"
            paddingTop="stack.xxxs"
            paddingLeft="inline.xxxs"
            paddingRight="inline.xxxs"
            h={undefined}
            isDisabled={disabled}
            _text={{ textTransform: 'none' }}>
            <Stack position="relative">
              <Icon name="Ordering" size="xxxs" color="neutral.black" />
              {hasSelection && (
                <Box
                  w={Typography['fontsize.md']}
                  h={Typography['fontsize.md']}
                  borderRadius="full"
                  background="brand.tertiary.light"
                  position="absolute"
                  top={-15}
                  right={-15}
                />
              )}
            </Stack>
          </Button>
        </HStack>

        <HStack alignItems="center" space="inline.nano">
          <Button
            variant="secondary"
            onPress={() => navigate('FixedFeeReportModal')}
            paddingBottom="stack.xxxs"
            paddingTop="stack.xxxs"
            paddingLeft="inline.xxxs"
            paddingRight="inline.xxxs"
            h={undefined}
            isDisabled={disabled}
            _text={{ textTransform: 'none' }}>
            <Icon name="FileExe" size="xxxs" color="neutral.black" />
          </Button>
          <Button
            variant="secondary"
            onPress={() => navigate('FixedFeeFilterModal')}
            _text={{ textTransform: 'none' }}
            paddingLeft="inline.xxxs"
            paddingRight="inline.xxxs"
            h={undefined}
            isDisabled={disabled}
            {...(!appliedFilters.length && {
              rightIcon: <Icon name="Funnel" size="xxxs" color="neutral.black" />,
            })}>
            <HStack alignItems="center" justifyContent="center" space="inline.nano">
              <Text variant="semibold" fontSize="md" color="neutral.black">
                Filtrar
              </Text>
              {!!appliedFilters.length && (
                <Box
                  borderRadius="full"
                  w="20px"
                  h="20px"
                  alignItems="center"
                  justifyContent="center"
                  bg="brand.tertiary.light">
                  <Text variant="regular" fontSize="xs" color="neutral.white">
                    {appliedFilters.length}
                  </Text>
                </Box>
              )}
            </HStack>
          </Button>
        </HStack>
      </HStack>
    </VStack>
  );
};
